<template>
	<video id="video" class="videoTransition centerHorizontalAbsolute" autoplay muted="true" volume="0"></video>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(this.$el);

    navigator.mediaDevices
      .enumerateDevices()
      .then(devices => {
        var devices1 = devices.filter(v => v.kind === "videoinput");
        console.log("Found ".concat(devices1.length).concat(" video devices"));

        let lastDevice = devices1[devices1.length - 1];
        var devices2 = devices.filter(v => v.label.indexOf("back") > 0);

        let device = null;
        if (devices2.length > 0) {
          console.log("Taking a 'back' camera");
          device = devices2[devices2.length - 1];
        } else {
          console.log("Taking last camera");
          device = lastDevice;
        }

        if (!device) {
          console.log("No devices!");
          return;
        }

        let constraints = {
          audio: {
            echoCancellation: true
          },
          video: {
            deviceId: { ideal: device.deviceId },
            width: 640,
            height: 480
          }
        };

        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.$el.srcObject = stream;
            this.$emit("initRecorder", stream);
          })
          .catch(err => {
            console.log(err.name.concat(": ").concat(err.message));
          });
      })
      .catch(err => {
        console.log(err.name.concat(": ").concat(err.message));
      });
    const video = document.querySelector("#video");
  }
};
</script>
